<template>
    <div>
        <template v-if="!isInitialized">
            <div class="block-container">
                <van-empty description="正在读取中..."/>
            </div>
        </template>
        <template v-if="isInitialized && fail">
            <div class="block-container">
                <van-empty :description="failMsg"/>
            </div>
        </template>
        <template v-if="!fail && isInitialized">
            <div style="display: flex; align-items: center; justify-content: center;">
                <div class="info-container">
                    <van-cell title="邀请人信息"></van-cell>
                    <van-cell>
                        <template>
                            <div class="user-info">
                                <van-image
                                    width="4rem"
                                    height="4rem"
                                    fit="cover"
                                    round
                                    :src="info.user_info.avatar"/>
                                <van-row>
                                    <span class="user-nickname">{{info.user_info.nickname}}</span>
                                </van-row>
                            </div>
                        </template>
                    </van-cell>
                    <van-cell title="卡片信息"></van-cell>
                    <div class="user-info" style="width: 100%;">
                        <card-design :card-info="info.card_info"/>
                    </div>
                    <van-cell class="user-info">
                        <template>
                            <van-button type="info" class="user-info-button" round @click="accessInvite()">接受邀请</van-button>
                        </template>
                    </van-cell>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import api from '../../assets/js/api'
    import cardDesign from '../../components/beilin/CardDesign.vue'

    export default {
        name: 'CompanyCardInvite',
        components: {cardDesign},
        data () {
            return {
                loading: false,
                isInitialized: false,
                fail: false,
                failMsg: '',
                info: {},
                id: this.$route.query.id,
            }
        },
        created() {
            api.request('/user_invite_use_card/info', {
                id: this.$route.query.id
            }).then(res => {
                this.info = res.data;
            }).catch(res => {
                this.fail = true;
                this.failMsg = res.msg
            }).finally(() => {
                this.isInitialized = true;
            })
        },
        methods: {
            accessInvite() {
                if (this.loading) return false;
                let self = this;
                this.loading = true;
                let toast = this.$toast.loading({
                    message: '请求发送中...',
                    forbidClick: true,
                    loadingType: 'spinner',
                    duration: 0,
                });
                api.request('/user_invite_use_card/accept', {
                    id: self.id
                }).then(res => {
                    self.$toast.clear(toast);
                    self.$toast.success(res.msg);
                    self.$router.push({
                        name : 'Card'
                    });
                }).catch(res => {
                    self.$toast.clear(toast);
                    self.$toast.fail(res.msg);
                }).finally(() => {
                    self.loading = false;
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
    .info-container {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 20px;
        width: 90%;
        flex-direction: column;
        .user-info {
            background: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            .user-nickname {
                margin-top: 15px;
                font-weight: bold;
                font-size: 16px;
                color: #666;
                display: block;
            }
            .user-info-button {
                width: 5rem;
                margin: 1rem 0;
            }
        }

        /deep/ .van-cell:nth-child(1) {
            border-top-left-radius: 0.5rem;
            border-top-right-radius: 0.5rem;
        }

        /deep/ .van-cell:last-child {
            border-bottom-left-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/company/companyCardInvite.vue